<template>
  <div id="app">
    <v-app light>
      <v-content>
        <section>
            <v-layout
              column
              align-center
              justify-center
              class="black--text">

              <img style="margin-top: 3rem" src="../assets/pie-logo.svg" alt="PIE Api" height="200">
              <h1 class="black--text mb-2 display-1 text-xs-center">PIE Content Services</h1>
              <div class="subheading mb-3 text-xs-center">Preview Release</div>
              
              <v-btn v-if="auth.isAuthenticated()"
                color="deep-orange"
                dark
                large
                href="/docs/getting-started.html">
                Get Started
              </v-btn>

              <v-btn v-else
                color="deep-orange"
                dark
                large
                @click="initLogin">
                Login
              </v-btn>

              <ErrorModal @close="showModal = false"
                :show="showModal"
                :errorType="errorType"
                :errorMsg="errorMsg">
              </ErrorModal>
            </v-layout>
        </section>
      </v-content>
    </v-app>
  </div>
</template>
<script>
import ErrorModal from "./ErrorModal.vue";

export default {
  name: "home",
  props: ["auth", "authenticated", "error"],
  components: { ErrorModal },
  data() {
    const showModal = !!this.error;
    return {
      showModal: showModal,
      errorType: this.error ? this.error.type : "",
      errorMsg: this.error ? this.error.message : ""
    };
  },
  methods: {
    initLogin() {
      this.auth.login();
    },
    initLogout() {
      this.auth.logout();
    }
  }
};
</script>

<style>
a {
  cursor: pointer;
}
</style>
